import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface SiteBranding {
  titleAr: string;
  titleEn: string;
  logoUrl: string;
  academyUrl: string;
}

export const DEFAULT_BRANDING: SiteBranding = {
  titleAr: 'منصة كفاح للابتكار',
  titleEn: 'Kifah Innovation Hub',
  logoUrl: '',
  academyUrl: 'https://alkifah.sch.sa',
};

export const BRANDING_KEY = 'site_branding';

export function useSiteBranding() {
  const [branding, setBranding] = useState<SiteBranding>(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await supabase
      .from('site_settings')
      .select('value')
      .eq('key', BRANDING_KEY)
      .maybeSingle();
    if (data?.value) {
      setBranding({ ...DEFAULT_BRANDING, ...(data.value as Partial<SiteBranding>) });
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
    const channel = supabase
      .channel('site_settings_branding')
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'site_settings', filter: `key=eq.${BRANDING_KEY}` },
        () => load()
      )
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  }, []);

  return { branding, loading, reload: load };
}
